import type { ReactElement } from 'react';
import { Spinner } from '../../../progress/Spinner/Spinner.component';

export const SelectLoadingIndicator = (): ReactElement => <Spinner size="s" subject="select-options" />;

SelectLoadingIndicator.displayName = 'SelectLoadingIndicator';
